export default "__VITE_ASSET__Daj0Myno__"